import { render } from "./AppTransaction.vue?vue&type=template&id=46f90e37&scoped=true"
import script from "./AppTransaction.vue?vue&type=script&lang=js"
export * from "./AppTransaction.vue?vue&type=script&lang=js"

import "./AppTransaction.vue?vue&type=style&index=0&id=46f90e37&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f90e37"]])

export default __exports__